function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { ActionsLayout, ToolbarActionsLayout } from '@leverege/ui-plugin';
import { DataSources } from '@leverege/ui-attributes';
import { UserSettings, GlobalState, Selection } from '@leverege/ui-redux';
import RolloverCard from "./RolloverCard.js";
export default class RolloverSelectionPointer {
  constructor(options) {
    this.getRolloverModel = createModelGetter('rolloverModel', options?.rolloverModel);
    this.pointerContext = {};
    const context = {
      use: 'contextMenu',
      client: 'GraphRolloverSelectionPointer'
    };
    const tContext = {
      use: 'itemBar',
      client: 'GraphRolloverSelectionPointer'
    };
    this.selectToolbar = new ToolbarActionsLayout({
      context: tContext,
      hasContextMenu: true
    });
    this.contextMenuLayout = new ActionsLayout({
      context
    });
    this.context = context;
  }
  setPointerContext(context) {
    this.pointerContext = context || {};
  }
  onSetRollover = obj => {
    if (obj) {
      GlobalState.dispatch(Selection.set('rollover', obj));
    } else {
      GlobalState.dispatch(Selection.clear('rollover'));
    }
  };
  getContext = target => {
    // Get Data for the targets
    const cxt = {
      ...this.pointerContext,
      ...this.context
    };
    if (target[0]) {
      cxt.target = DataSources.withData(target);
    }
    return cxt;
  };

  /**
   * Render the rollover card
   */
  renderRollover = props => {
    return /*#__PURE__*/React.createElement(RolloverCard, _extends({
      getRolloverModel: this.getRolloverModel,
      getContext: this.getContext,
      onSetRollover: this.onSetRollover
    }, props));
  };
}
function createModelGetter(name, funcOrObj) {
  return () => {
    if (typeof funcOrObj === 'function') {
      return funcOrObj;
    }
    if (funcOrObj != null) {
      return funcOrObj;
    }
    const toReturn = UserSettings.get(GlobalState.get(), name);
    if (toReturn instanceof Promise) {
      return null;
    }
    return toReturn;
  };
}